import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt } from 'react-icons/fa';
import logo from '../assets/logo.jpg';

const Guarantee = () => {
    return (
        <section className="py-20 bg-black">
            <div className="max-w-6xl mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="relative overflow-hidden p-8 md:p-20 rounded-[3rem] bg-white text-black text-center shadow-[0_0_50px_rgba(255,255,255,0.1)]"
                >
                    {/* Brand Watermark */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-full pointer-events-none opacity-[0.03] rotate-12">
                        <img src={logo} alt="" className="w-full h-full object-contain" />
                    </div>

                    <div className="relative z-10 max-w-3xl mx-auto">
                        <div className="inline-flex items-center gap-2 px-6 py-2 bg-black text-white rounded-full mb-10 font-bold text-sm tracking-widest uppercase">
                            <FaShieldAlt className="text-blue-500" />
                            Garantovani Rezultati
                        </div>

                        <h2 className="text-4xl md:text-6xl font-black mb-10 leading-[1.1] tracking-tight">
                            Ako za 14 dana ne automatizujemo 80% upita <span className="text-blue-600">radimo besplatno</span> dok ne postignemo.
                        </h2>

                        <p className="text-lg md:text-xl font-medium opacity-70 leading-relaxed">
                            Pod "ponavljajućim upitima" podrazumevamo najčešće kategorije kao što su status porudžbine, zamene, i opšte informacije. Merimo uspeh na osnovu preciznosti i brzine odgovora.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Guarantee;
